import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Form, Button, Row, Spinner, Col, Navbar } from 'react-bootstrap';
import { useAuth } from '../context/auth';
import { SettingContext } from '../context/SettingContext';
import UserContext from '../context/ThemeContext';
import { loginService } from '../services/loginService';
import ErrorModal from './ErrorModal';
import '../stylesheets/APIProgress.css';
import '../stylesheets/LoginPage.css';
const Login = () => {

  const { translatedContent } = React.useContext(SettingContext);
  const { dimensions } = React.useContext(UserContext);

  const [isLoggedIn, setLoggedIn] = useState(localStorage.getItem('tokens') || '');
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorDesc, setErrorDesc] = useState('');
  const [showError, setShowError] = useState(false);
  const { setAuthTokens } = useAuth();
  const [showSpinner, setShowSpinner] = useState(false);

  const postLogin = () => {
    setShowSpinner(true);
    const credentials = {
      'username': userName,
      'password': password
    };
    let AuthToken;
    loginService(credentials).then(result => {

      if (result.status === 200) {

        AuthToken = result.data;
        localStorage.setItem('tokens', AuthToken.token);
        localStorage.setItem('terminals', JSON.stringify(AuthToken.terminals));

        if (!localStorage.language) {
          localStorage.setItem('language', 'English');
        }
        if (!localStorage.currency) {
          localStorage.setItem('currency', 'Euro');
        }
        if (!localStorage.operatorId) {
          localStorage.setItem('operatorId', '');
        }

        setAuthTokens(result.data.token);
        setShowSpinner(false);
        setLoggedIn(true);
      }
      else {

        if (result.message === 'Network Error') {
          setShowSpinner(false);
          setErrorDesc('NetworkError');
          setShowError(true);
        } else if (result.response.status === 401) {
          setShowSpinner(false);
          setErrorDesc('InvalidCredentials');
          setShowError(true);
        }
        else {
          setShowSpinner(false);
          setErrorDesc('SomethingWrong');
          setShowError(true);
        }
      }
    });
  };

  const togglePass = () => {
    setShowPassword(!showPassword);
  };

  const closeError = () => {
    setShowError(false);
  };

  if (isLoggedIn !== '') {
    return <Redirect to="/" />;
  }

  return (
    !showSpinner ?
      !showError ?
        <>
          <Row className="mt-4">
            <Col md={{ span: 4, offset: 4 }} >
              <Form>
                <Form.Group controlId="formUsername">
                  <Form.Label>{translatedContent.UserName}</Form.Label>
                  <Form.Control
                    value={userName}
                    onChange={e => { setUserName(e.target.value); }}
                    type="email" placeholder={'Enter ' + translatedContent.UserName} />
                </Form.Group>

                <Form.Group controlId="formPassword">
                  <Form.Label>{translatedContent.Password}</Form.Label>
                  <Form.Control
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value);
                    }}
                    type={showPassword ? 'text' : 'password'} placeholder={'Enter ' + translatedContent.Password} />
                </Form.Group>
                <Form.Group controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" label="Show Password" onChange={() => {
                    togglePass();
                  }} />
                </Form.Group>
                <Button variant="primary" id="loginButton"
                  onClick={postLogin}
                >
                  {translatedContent.Login}
                </Button>
              </Form>
            </Col>
          </Row>
          <Navbar className="Version-detail" fixed="bottom" bg="light">
            Version: {process.env.REACT_APP_VERSION}
          </Navbar>
        </>
        : <ErrorModal show={showError} translate={translatedContent.ErrorCode} errorDesc={errorDesc} closeError={closeError} isMobile={dimensions.isMobile} />
      :
      <div className="d-flex justify-content-center custom-vertical-align">
        <Spinner animation="border" variant="primary" />
      </div>
  );
};

export default Login;